import { render, staticRenderFns } from "./AssessmentTemplateMemoPrinterExample.vue?vue&type=template&id=448da61d"
import script from "./AssessmentTemplateMemoPrinterExample.vue?vue&type=script&lang=js"
export * from "./AssessmentTemplateMemoPrinterExample.vue?vue&type=script&lang=js"
import style0 from "./AssessmentTemplateMemoPrinterExample.vue?vue&type=style&index=0&id=448da61d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports